import TermList from "../AdminTermList";

export default class AdminTermListActivityFileType extends TermList {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "activity_file_type";
    }
}
